<template>
    <div class="self-train-block-container">
        <!-- 分割线 -->
        <div class="split">
            <div class="line">
                <div class="dashed"></div>
            </div>
            <div class="title">
                <img class="logo" src="../../../assets/img/self-train-split.svg" alt="">
                <div class="title-str">{{ category }}</div>
            </div>
            <div class="line">
                <div class="dashed"></div>
            </div>
        </div>
        <!-- 项目清单 -->
        <div class="item-list-container">
            <div class="item" v-for="item in selfTrainItemList" :key="item.id"
                @click="() => handleFinishSelfTrainItem(item)">
                <img :src="item.backgroundImage" class="logo" :style="{ backgroundColor: item.finishColor }">
                <span class="content">{{ item.name }}</span>
                <span class="count">{{ item.continueDays === 0 || !item.continueDays ? 0 : item.continueDays }}天</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: String,
            required: true,
        },
        selfTrainItemList: {
            type: Array,
            required: true,
        },
    },
    methods: {
        // 完成自律项目
        handleFinishSelfTrainItem(item) {
            let _self = this;
            // 1.先判断今天有没有已经点击完成过了
            let now = new Date;
            let d1 = new Date(now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0') + '-' + now.getDate().toString().padStart(2, '0'));// 前端计算的当前日期
            let d2 = new Date(item.lastFinishTime);// 后端传过来的上一次完成日期
            if (d1.getTime() == d2.getTime()) {// 如果两个日期相等,说明今天已经点过完成了
                _self.$toast.fail("今天已经完成过了哦!!!");
            } else {// 如果两个日期不相等,说明今天还没有点过完成
                // 记得要重置finishColor属性为null,不然传到后端是#ffffff
                item.finishColor = null;

                // 二次确认,避免误点
                _self.$dialog.confirm({
                    title: '确认打卡吗?',
                    message: '',
                })
                    .then(() => {
                        // 2.提交完成
                        _self.$api.selftrain
                            .finishSelfTrainItem(item)
                            .then(
                                res => {
                                    if (res.returnCode === 200) {
                                        _self.$toast.success("打卡成功，你是最棒的!!!");
                                        _self.$emit("finishSelfTrainItem");
                                    } else {
                                        _self.$toast.fail(res.returnMsg);
                                    }
                                },
                                error => {
                                    console.log(error);
                                    _self.$toast.fail("服务器忙，请稍后重试");
                                }
                            )
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(() => {
                        // on cancel
                    });


            }

        }
    }
}
</script>

<style scoped>
.self-train-block-container {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.self-train-block-container .split {
    display: flex;
    width: 100%;
    height: 20px;
    padding: 0 8px;
}

.self-train-block-container .split .line {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.self-train-block-container .split .line .dashed {
    border-top: 1px dashed #c0c0c0;
    width: 100%;
}


.self-train-block-container .split .title {
    display: flex;
    flex-direction: row;
    padding-left: 4px;
}

.self-train-block-container .split .title .logo {
    width: 16px;
    height: 20px;
}

.self-train-block-container .split .title .title-str {
    flex-grow: 1;
    line-height: 20px;
    font-size: 16px;
    font-weight: bold;
}

.self-train-block-container .item-list-container {
    display: flex;
    flex-direction: row;
    padding: 0 8px;
    flex-wrap: wrap;
}

.self-train-block-container .item-list-container .item {
    display: flex;
    flex-direction: column;
    width: 25%;
    align-items: center;
    justify-content: flex-start;
}

.self-train-block-container .item-list-container .item .logo {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px dashed black;
    padding: 4px;
}

.self-train-block-container .item-list-container .item .content {
    font-size: 12px;
    font-weight: 900;
    text-align: center;
}

.self-train-block-container .item-list-container .item .count {
    font-size: 10px;
    font-weight: 400;
    margin-bottom: 2px;
}
</style>